import { render, staticRenderFns } from "./SheetMenuPopper.vue?vue&type=template&id=284b0472&"
import script from "./SheetMenuPopper.vue?vue&type=script&lang=js&"
export * from "./SheetMenuPopper.vue?vue&type=script&lang=js&"
import style0 from "./SheetMenuPopper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports